import { render, staticRenderFns } from "./TestingCenterTime.vue?vue&type=template&id=6646cf6f&"
import script from "./TestingCenterTime.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports